import { useAccount } from 'wagmi'

export function useEoaAccount() {
  const { address } = useAccount()

  return {
    account: address,
  }
}
